import {Flur} from "./flur";

export class Landregisterfolio{
  constructor() {
  this.flure.push(new Flur())}
  id: string;
  number: string;
  gemarkung: string;
  flure: Array<Flur> = [];
}
